import React from 'react'
import { Container, Form, Button, Image, Row, Col, Nav, NavDropdown } from 'react-bootstrap';
import { getAuth, signOut } from "firebase/auth";
import SideNav from '../components/SideNav';
import { OrderSummaryCards } from './OrderPage';
import Topbar from '../components/Topbar';
import CalendarComponent from "../components/CalendarComponent";


function Calendar() {

    const userId = window.localStorage.getItem('projectUserUID');


  return (
   <Container fluid className='p-3' style={{backgroundColor:"#F9FAFB", height:"100vh",}}>
    <Row>
        <Col className='col-auto' >
        <SideNav />
        </Col>
        <Col style={{padding:"0px 10px 0px 20px",flexGrow:1}}>
       {/* <Topbar  userId={userId}/> */}
            <Row className='mt-0'>
                <Col  className='p-4' style={{backgroundColor:"#fff", borderRadius: '10px',color:'white',marginRight:'5px',height:'96vh'}}>
                    {/* <OrderSummaryCards  /> */}
                    <CalendarComponent />
                </Col>
            </Row>
        </Col>
        </Row>
   </Container>
  ) 
}

export default Calendar